import { connect } from 'react-redux';
import { isCurrentEpisodeLocked } from './helpers';

const mapState = (state, ownProps) => ({
  authorized: !isCurrentEpisodeLocked(state)
});

const withPaidCheck = (AuthorizedComponent, NotAuthorizedComponent) => connect(mapState)(
  ({ authorized, ...rest }) => (
    authorized
      ? <AuthorizedComponent {...rest} />
      : <NotAuthorizedComponent />
  )
);

export { withPaidCheck };
